import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_COMPANIES_BY_CLASS_ID = gql`
  query GetViewedCompanyProfiles($classId: Int!) {
    getViewedCompanyProfiles(schoolClassID: $classId) {
      id
      name
      visits
      companyProfilePicture {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
